import { Outlet } from "react-router";

import { useShadowProfile } from "@/features/auth/use-shadow-profile";

/**
 * Layout route for pages that need the access record's `globalAccess` grant:
 * the shared tables, and the internal-only views of one organization's data
 * (verification review). The message is for someone who typed the URL; the
 * sidebar never links here without the grant, and the API refuses every
 * route behind it, so this is a courtesy rather than the control.
 */
export const GlobalAccessGate = () => {
	const { error, globalAccess, isLoading } = useShadowProfile();

	if (isLoading) {
		return <p className="text-secondary text-sm">Loading your access…</p>;
	}

	if (error) {
		return (
			<p className="text-error-primary text-sm">
				Could not load your access. {error.message}
			</p>
		);
	}

	if (!globalAccess) {
		return (
			<p className="text-secondary text-sm">
				Your account does not have global access. This page is for internal
				staff; ask an administrator to set it on your ShadowAccess record.
			</p>
		);
	}

	return <Outlet />;
};
